module.exports = __webpack_public_path__ + "static/drivex-2513df6e738bba02349e9207c9230a46.png";